import { Component } from "@angular/core";
import { Toast, ToastrService, ToastPackage } from "ngx-toastr";
import { BPGlobalConfig } from "@modules/notifications/domain/entities/notifications.model";

@Component({
	selector: "[global-notifications]",
	styleUrls: ["./bp-global-notifications.component.scss"],
	templateUrl: "./bp-global-notifications.component.html",
	standalone: false
})
export class BpGlobalNotificationsComponent extends Toast {
	public options: BPGlobalConfig;
	public title: string = this.toastPackage.title;
	public message: string = this.toastPackage.message;
	public action: boolean = this.options.showAction;
	public actionMessage: string = this.options.actionMessage;
	public closeButton: boolean = this.options.closeButton;
	public notificationType: string = this.toastPackage.toastType;

	constructor(
		protected toastrService: ToastrService,
		public toastPackage: ToastPackage
	) {
		super(toastrService, toastPackage);
	}

	public onActionClick(event: Event): boolean {
		this.toastPackage.triggerTap();
		event.stopPropagation();
		return false;
	}

	public onCloseClick(): void {
		this.toastPackage.triggerAction("close");
		this.toastrService.clear();
	}
}
